export default {"src":"/_next/static/media/independent-living-icon.9c217081.svg","height":80,"width":109,"blurWidth":0,"blurHeight":0};